import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nr-pill--text shim-pill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIcon = _resolveComponent("NrIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classNames)
  }, [
    _createVNode(_component_NrIcon, { name: "wrench" }),
    _createElementVNode("span", _hoisted_1, _toDisplayString($props.label), 1)
  ], 2))
}